import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

const Unprotected = (props) => {
  const navigate = useNavigate()
  const authInfo = useSelector((state) => state.auth)

  useEffect(() => {
    // When auth state changes after login, redirect immediately
    if (authInfo?.isAuthenticated && authInfo?.user) {
      if (authInfo?.user?.role === 'support') {
        navigate('/dashboard/tutors', { replace: true })
      } else {
        navigate('/dashboard/enqueries/pending', { replace: true })
      }
    }
  }, [authInfo?.isAuthenticated, authInfo?.user, navigate])

  return props.children
}

export default Unprotected